import { getHandleId, getTargetHandleStyle } from '@common-services/utils'
import { Handle, Position } from 'reactflow'
import { nodeTypes } from '../bt-nodes-def'
import NodeContainer from '../node-container'
import { memo } from 'react'


type HandleSlot = { id?: string };
type WebhookNodeProps = {
    id: string;
    data: { handles?: { inputs?: HandleSlot[]; outputs?: HandleSlot[] } };
};

function WebhookNode({ id, data }: WebhookNodeProps) {

    const nodeColor = nodeTypes.webhook.color


    return (
        <>
            <Handle type="target" position={Position.Left} id={getHandleId(data.handles, 'target', 0) ?? undefined}
                style={{
                    zIndex: 3,
                    ...getTargetHandleStyle(nodeColor),
                }} />
            <NodeContainer type="webhook" id={id} />
        </>
    )
}

export default memo(WebhookNode);